// extracted by mini-css-extract-plugin
module.exports = {"container":"SubmissionPayment_container__1JBLV","content":"SubmissionPayment_content__3Fv_X","row":"SubmissionPayment_row__2X1wk","rowTitle":"SubmissionPayment_rowTitle__A7QOX"};